<template>
  <div>
    <dv-border-box-7>
      <div style="padding: 10px">
        <el-row :gutter="30">
          <el-col :span="15">
            <div style="color: #fccc66; line-height: 30px">
              辐射全国的草莓产业格局
            </div>
            <dv-flyline-chart-enhanced
              :config="configFly1"
              style="width: 100%; height: 340px"
            />
            <marquee-text :duration="25">
              <div style="color: #cfcfcf">
                全县建立 <span class="digital-1">5</span> 处脱毒组培中心；
                草莓原原种苗繁育能力 <span class="digital-1">100万</span> 株以上；
                育苗面积近 <span class="digital-1">4万</span> 亩； 满足全国
                <span class="digital-1">30万</span> 亩草莓种植需求；
                长丰县连续成功举办
                <span class="digital-1">18</span>
                届草莓文化节，长丰草莓热销
                <span class="digital-1">北京</span> 、
                <span class="digital-1">天津</span> 、
                <span class="digital-1">南京</span> 、
                <span class="digital-1">上海</span> 、
                <span class="digital-1">深圳</span> 及
                <span class="digital-1">东北</span>
                等地。形成辐射全国的产业格局。
              </div>
            </marquee-text>
          </el-col>
          <el-col :span="9">
            <div style="color: #fccc66; line-height: 30px">
              立足安徽的特色化草莓产业集成区
            </div>
            <dv-flyline-chart-enhanced
              :config="configFly2"
              style="width: 100%; height: 350px; margin-top: -10px"
            />

            <marquee-text :duration="20">
              <span style="color: #cfcfcf">
                围绕着做大做强长丰草莓品牌规划，通过
                <span class="digital-2">种苗供应</span> 、
                <span class="digital-2">草莓标准生产模式输出</span>
                等方式，立足长丰，辐射带动
                <span class="digital-2">淮南</span> 、
                <span class="digital-2">阜阳</span> 、
                <span class="digital-2">定远</span> 、
                <span class="digital-2">六安</span>
                等周边县市共同发展草莓业，形成特色化草莓产业集成区。
              </span>
            </marquee-text>
          </el-col>
        </el-row>
      </div>
    </dv-border-box-7>
  </div>
</template>
<script>
import VueMarquee from 'vue-marquee'
// npm install vue-marquee-text-component@1.2.0
import MarqueeText from 'vue-marquee-text-component'
export default {
  components: { VueMarquee, MarqueeText },
  data() {
    return {
      configFly1: {
        points: [
          {
            name: '长丰',
            coordinate: [0.668, 0.54],
            halo: { show: true },
            icon: { src: 'berry-icon.png', width: 42, height: 32 },
            text: { show: false },
          },
          { name: '山东', coordinate: [0.693, 0.393], text: { show: true } },
          { name: '河南', coordinate: [0.617, 0.49], text: { show: true } },
          { name: '湖北', coordinate: [0.573, 0.54], text: { show: true } },
          { name: '湖南', coordinate: [0.574, 0.681], text: { show: true } },
          { name: '云南', coordinate: [0.38, 0.829], text: { show: true } },
          { name: '辽宁', coordinate: [0.776, 0.24], text: { show: true } },
          { name: '内蒙古', coordinate: [0.584, 0.209], text: { show: true } },
          { name: '西安', coordinate: [0.5329, 0.424], text: { show: true } },
          { name: '太原', coordinate: [0.562, 0.309], text: { show: true } },
          { name: '北京', coordinate: [0.6634, 0.25], text: { show: true } },
          { name: '天津', coordinate: [0.677, 0.29], text: { show: true } },
          { name: '上海', coordinate: [0.75, 0.58], text: { show: true } },
          { name: '深圳', coordinate: [0.61, 0.87], text: { show: true } },
          { name: '南京', coordinate: [0.6994, 0.5822], text: { show: true } },
        ],
        lines: [
          { target: '山东', source: '长丰' },
          { target: '河南', source: '长丰' },
          { target: '湖北', source: '长丰' },
          { target: '湖南', source: '长丰' },
          { target: '云南', source: '长丰' },
          { target: '辽宁', source: '长丰' },
          { target: '内蒙古', source: '长丰' },
          { target: '西安', source: '长丰' },
          { target: '太原', source: '长丰' },
          { target: '北京', source: '长丰' },
          { target: '天津', source: '长丰' },
          { target: '上海', source: '长丰' },
          { target: '深圳', source: '长丰' },
          { target: '南京', source: '长丰' },
        ],
        bgImgSrc: require('./china.png'),
      },
      configFly2: {
        points: [
          {
            name: '长丰',
            coordinate: [0.52, 0.52],
            halo: { show: true },
            icon: { src: 'berry-icon.png', width: 42, height: 32 },
            text: { show: true },
          },
          { name: '亳州', coordinate: [0.375, 0.2], text: { show: true } },
          { name: '阜阳', coordinate: [0.377, 0.37], text: { show: true } },
          { name: '宿州', coordinate: [0.481, 0.239], text: { show: true } },
          { name: '六安', coordinate: [0.441, 0.567], text: { show: true } },
          { name: '蚌埠', coordinate: [0.518, 0.365], text: { show: true } },
          { name: '芜湖', coordinate: [0.614, 0.63], text: { show: true } },
          { name: '安庆', coordinate: [0.496, 0.717], text: { show: true } },
          { name: '滁州', coordinate: [0.591, 0.466], text: { show: true } },
        ],
        lines: [
          { target: '亳州', source: '长丰' },
          { target: '阜阳', source: '长丰' },
          { target: '宿州', source: '长丰' },
          { target: '六安', source: '长丰' },
          { target: '蚌埠', source: '长丰' },
          { target: '芜湖', source: '长丰' },
          { target: '安庆', source: '长丰' },
          { target: '滁州', source: '长丰' },
        ],
        bgImgSrc: require('./anhui.png'),
      },
    }
  },
}
</script>
<style scoped>
.digital-1 {
  background-color: #ff6666;
  color: #fff;
  padding: 0 10px 0 8px;
  border-radius: 6px;
}
.digital-2 {
  background-color: #63b66f;
  color: #fff;
  padding: 0 10px 0 8px;
  border-radius: 6px;
}
</style>


// WEBPACK FOOTER //
// src/components/screen38496/influence-zone/index.vue